export default __webpack_public_path__ + "static/media/digest-create-group-icon.ff89fcb6.svg";